import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { BrowserRouter, Routes, Route, useLocation, Switch, useHistory } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import { AppTopbar } from "./AppTopbar";
import { AppFooter } from "./AppFooter";
import { AppMenu } from "./AppMenu";
import { AppConfig } from "./components/AppConfig/AppConfig";
import PrimeReact from "primereact/api";
import { Tooltip } from "primereact/tooltip";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingOverlay from "react-loading-overlay";
import "primereact/resources/primereact.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "prismjs/themes/prism-coy.css";
import "./assets/demo/flags/flags.css";
import "./assets/demo/Demos.scss";
import "./assets/layout/layout.scss";
import "./App.scss";
import Login from "./pages/login/Login";
import ForgotPassword from "./pages/login/forgetpassword/ForgotPassword";
import ResetPassword from "./pages/login/ResetPassword/ResetPassword";
import { Dialog } from 'primereact/dialog';
import { useSelector } from "react-redux";
import ManageContact from "./pages/ContactUs/ManageContact";
import AddEditContact from "./pages/ContactUs/AddEditContact";
import ManageCategory from "./pages/Categories/ManageCategory";
import AddEditCategory from "./pages/Categories/AddEditCategory";
import ManageMenu from "./pages/Menus/ManageMenu";
import AddEditMenu from "./pages/Menus/AddEditMenu";
import ManageOrder from "./pages/Orders/ManageOrder";
import ManageJobApplication from "./pages/JobApplications/ManageJobApplication";
import ManagePromocode from "./pages/Promocodes/ManagePromocode";
import AddEditPromocode from "./pages/Promocodes/AddEditPromocode";

const App = () => {

    // "start": "env-cmd -f .env.development react-scripts start",
    const [layoutMode, setLayoutMode] = useState("static");
    const [layoutColorMode, setLayoutColorMode] = useState("light");
    const [inputStyle, setInputStyle] = useState("outlined");
    const [ripple, setRipple] = useState(true);
    const [staticMenuInactive, setStaticMenuInactive] = useState(false);
    const [overlayMenuActive, setOverlayMenuActive] = useState(false);
    const [mobileMenuActive, setMobileMenuActive] = useState(false);
    const [mobileTopbarMenuActive, setMobileTopbarMenuActive] = useState(false);
    const [countdown, setCountdown] = useState(5);
    const [showPopup, setShowPopup] = useState(false);

    const login = localStorage.getItem('login')

    const intervalRef = useRef();
    const copyTooltipRef = useRef();
    const location = useLocation();
    const history = useHistory()

    const token = useSelector((state) => state?.logoutSlice?.token);

    useEffect(() => {
        if (!token) {
            // history.push('/');
        }
    }, [token]);


    PrimeReact.ripple = true;
    let menuClick = false;
    let mobileTopbarMenuClick = false;

    useEffect(() => {
        if (mobileMenuActive) {
            addClass(document.body, "body-overflow-hidden");
        } else {
            removeClass(document.body, "body-overflow-hidden");
        }
    }, [mobileMenuActive]);

    useEffect(() => {
        copyTooltipRef && copyTooltipRef.current && copyTooltipRef.current.updateTargetEvents();
    }, [location]);

    const onInputStyleChange = (inputStyle) => {
        setInputStyle(inputStyle);
    };

    const onRipple = (e) => {
        PrimeReact.ripple = e.value;
        setRipple(e.value);
    };

    const onLayoutModeChange = (mode) => {
        setLayoutMode(mode);
    };

    const onColorModeChange = (mode) => {
        setLayoutColorMode(mode);
    };

    const onWrapperClick = (event) => {
        if (!menuClick) {
            setOverlayMenuActive(false);
            setMobileMenuActive(false);
        }

        if (!mobileTopbarMenuClick) {
            setMobileTopbarMenuActive(false);
        }

        mobileTopbarMenuClick = false;
        menuClick = false;
    };

    const onToggleMenuClick = (event) => {

        menuClick = true;
        if (isDesktop()) {
            if (layoutMode === "overlay") {
                if (mobileMenuActive === true) {
                    setOverlayMenuActive(true);
                }

                setOverlayMenuActive((prevState) => !prevState);
                setMobileMenuActive(false);
            } else if (layoutMode === "static") {
                setStaticMenuInactive((prevState) => !prevState);
            }
        } else {
            setMobileMenuActive((prevState) => !prevState);
        }
        event.preventDefault();
    };

    const onSidebarClick = () => {
        menuClick = true;
    };

    const onMobileTopbarMenuClick = (event) => {
        mobileTopbarMenuClick = true;
        setMobileTopbarMenuActive((prevState) => !prevState);
        event.preventDefault();
    };

    const onMobileSubTopbarMenuClick = (event) => {
        mobileTopbarMenuClick = true;
        event.preventDefault();
    };

    const onMenuItemClick = (event) => {
        if (!event?.item?.items) {
            setOverlayMenuActive(false);
            setMobileMenuActive(false);
        }
    };

    const isDesktop = () => {
        return window.innerWidth >= 992;
    };

    const sideBarMenu = [
        {
            items: [
                {
                    label: "Categories",
                    icon: "pi pi-tags",
                    to: "/categories",
                },
                {
                    label: "Menus",
                    icon: "pi pi-list",
                    to: "/menus",
                },
                {
                    label: "Orders",
                    icon: "pi pi-shopping-cart",
                    to: "/orders",
                },
                {
                    label: "Job Applications",
                    icon: "pi pi-briefcase",
                    to: "/job-applications",
                },
                {
                    label: "Promocodes",
                    icon: "pi pi-ticket",
                    to: "/promocodes",
                },
                {
                    label: "Contacts",
                    icon: "pi pi-envelope",
                    to: "/contacts",
                },
            ],
        },
    ];

    const addClass = (element, className) => {
        if (element.classList) element.classList.add(className);
        else element.className += " " + className;
    };

    const removeClass = (element, className) => {
        if (element.classList) element.classList.remove(className);
        else element.className = element.className.replace(new RegExp("(^|\\b)" + className.split(" ").join("|") + "(\\b|$)", "gi"), " ");
    };

    const wrapperClass = classNames("layout-wrapper", {
        "layout-overlay": layoutMode === "overlay",
        "layout-static": layoutMode === "static",
        "layout-static-sidebar-inactive": staticMenuInactive && layoutMode === "static",
        "layout-overlay-sidebar-active": overlayMenuActive && layoutMode === "overlay",
        "layout-mobile-sidebar-active": mobileMenuActive,
        "p-input-filled": inputStyle === "filled",
        "p-ripple-disabled": ripple === false,
        "layout-theme-light": layoutColorMode === "light",
    });


    LoadingOverlay.propTypes = undefined;

    return (

        <div className={wrapperClass} onClick={onWrapperClick}>

            {/* <LoadingOverlay active={isLoading} spinner text="Loading ..."> */}
            <ToastContainer />
            <Tooltip ref={copyTooltipRef} target=".block-action-copy" position="bottom" content="Copied to clipboard" event="focus" />

            {(!localStorage.getItem("login") || !localStorage.getItem("login") === undefined) ?
                (
                    <>
                        <Switch>
                            <Route exact path="/" component={Login} />
                            <Route exact path="/forgotPassword" component={ForgotPassword} />
                            <Route exact path="/reset-password" component={ResetPassword} />
                        </Switch>
                    </>
                ) : (
                    <>
                        <AppTopbar onToggleMenuClick={onToggleMenuClick} layoutColorMode={layoutColorMode} mobileTopbarMenuActive={mobileTopbarMenuActive} onMobileTopbarMenuClick={onMobileTopbarMenuClick} onMobileSubTopbarMenuClick={onMobileSubTopbarMenuClick} />
                        <div className="layout-sidebar" onClick={onMenuItemClick}>
                            <AppMenu model={sideBarMenu} onMenuItemClick={onMenuItemClick} layoutColorMode={layoutColorMode} />
                        </div>

                        <div className="layout-main-container innr-Body">
                            <div className="layout-main">
                                <Switch>
                                    <Route path="/categories" component={ManageCategory} />
                                    <Route path="/addeditcategory" component={AddEditCategory} />
                                    <Route path="/menus" component={ManageMenu} />
                                    <Route path="/addeditmenu" component={AddEditMenu} />
                                    <Route path="/orders" component={ManageOrder} />
                                    <Route path="/job-applications" component={ManageJobApplication} />
                                    <Route path="/promocodes" component={ManagePromocode} />
                                    <Route path="/addeditpromocode" component={AddEditPromocode} />                                    
                                    <Route path="/contacts" component={ManageContact} />
                                    <Route path="/addeditcontact" component={AddEditContact} />
                                </Switch>
                            </div>
                            {/* <AppFooter layoutColorMode={layoutColorMode} /> */}
                        </div>
                    </>
                )
            }

            <AppConfig rippleEffect={ripple} onRippleEffect={onRipple} inputStyle={inputStyle} onInputStyleChange={onInputStyleChange} layoutMode={layoutMode} onLayoutModeChange={onLayoutModeChange} layoutColorMode={layoutColorMode} onColorModeChange={onColorModeChange} />
            <CSSTransition classNames="layout-mask" timeout={{ enter: 200, exit: 200 }} in={mobileMenuActive} unmountOnExit>
                <div className="layout-mask p-component-overlay"></div>
            </CSSTransition>
            {/* </LoadingOverlay> */}

        </div>
    );
};


export default App;
